import { render } from "./pagetips.vue?vue&type=template&id=a1fa12d4"
import script from "./pagetips.vue?vue&type=script&lang=js"
export * from "./pagetips.vue?vue&type=script&lang=js"

import exportComponent from "E:\\newwww\\shared_space\\shared_store\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__